<ng-container [appPreloader]="[
                endpoints.BANK_ACCOUNTS_GET,
                endpoints.BANK_ACCOUNTS_POST,
                endpoints.BANK_CONNECTION_POST
              ]"
  [preloaderType]="preloaderTypes.OVERLAY">
</ng-container>

<div mat-dialog-title class="bank-connections-dialog-content">
  <div class="dialog-caption" [title]="connection.bank.name">
    <div class="align-v-center">
      <app-image [src]="connection.bank | call:'getPhoto'" [size]="40" borderRadius="none"></app-image>
      <div class="ml-10 bank-name">{{connection.bank.name}}</div>
    </div>
  </div>
  <button mat-dialog-close class="btn icon-close"></button>
</div>

@if (connection.externalId) {
  <app-bank-accounts-import-form
    #formComponent
    [connection]="connection"
    class="h-100 f-column"
    (back)="back.emit()"
    (submitted)="save($event)">
  </app-bank-accounts-import-form>
}

@if (!connection.externalId) {
  <app-bank-account-manual-form
    #formComponent
    [bankAccount]="bankAccount"
    class="h-100 f-column"
    (back)="back.emit()"
    (submitted)="save($event)"
    (connectionSaved)="connectionSaved.emit($event)">
  </app-bank-account-manual-form>
}
